/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './index.scss'
// import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { Row, Col, Alert, message } from 'antd'
import { compose } from 'recompose'
import _ from 'lodash'
import { loadScripts } from '../../App/app/scripts'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

import DataSubscriber from './dataSubscriber'
import ManualLog from './manualLog'
import BarangayName from '../../../components/Custom/BarangayName'
import BarangayLogo from '../../../components/Custom/BarangayLogo'
import ViewDetails from '../../Certificates/modalDetails'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			scannedData: null,
			error: null,
			isManualLogShown: false,
			isSavingManualLog: false,
			isViewDetailShown: false,
			scannedConstituentUid: null
		}

		this.handleFullFocus = this.handleFullFocus.bind(this)
		this.handleQRScan = this.handleQRScan.bind(this)
		this.handleSaveLog = this.handleSaveLog.bind(this)
		this.handleManualLog = this.handleManualLog.bind(this)
		this.handleSaveManualLog = this.handleSaveManualLog.bind(this)
	}

	componentDidMount () {
		var that = this
		setTimeout(function () {
		  loadScripts()
		  that.handleFullFocus()
		  that.handleManualLog()
		}, 1000)
	}

	handleManualLog () {
		if(document.addEventListener){ //code for Moz
			document.addEventListener('keydown', onKeypress, false)
		} else { // cod for IE
			document.attachEvent('onkeydown', onKeypress)
		}

		var that = this
		function onKeypress(e) {
			if(typeof window.event!='undefined'){
				e = window.event//code for IE
			}

			let code = e.keyCode || e.charCode
			if (code == 113 || e.key === 'F2') {
				that.handleFullScreen()
				that.setState({ isManualLogShown: true })
			}
		}
	}

	handleFullFocus () {
		var inputElement = document.getElementById('qr-input')
		inputElement.focus()
		inputElement.addEventListener('blur', function(event){
			inputElement.focus()
		})
	}

	handleQRScan (e) {
		e.preventDefault()
		const scannedValue = e.target.value
		if (IsJsonString(scannedValue)) {
			if (this.state.scannedData) {
				this.setState({ error: new Error('Input not yet ready') }, () => {
					var that = this
					setTimeout(() => {
						that.setState({ error: null })
					}, 5000)
				})
				return this.handleFullFocus()
			}

			this.handleSaveLog(JSON.parse(scannedValue))
			e.target.value = ''
		}

		var that = this
		setTimeout(() => {
			var qrinput = document.getElementById('qr-input')
			qrinput.value = ''
			that.handleFullFocus()
		}, 3000)
	}

	handleSaveLog(data) {
		const { saveLogs, saveDTRLogs } = this.props
		console.log('scannedValue', data)
		if (!_.isObject(data)) return this.handleFullFocus()

		if (_.isEqual(data.user_type, 'EMPLOYEE')) {
			this.setState({ isSaving: true }, () => {
				let newData = Object.assign({}, data, { data_source: 'QRCode' })
				saveDTRLogs(newData)
					.then((response) => {
						this.setState({ isSaving: false })
						this.handleFullFocus()
					})
					.catch(err => {
						console.log('error saving dtr logs', err)
						this.setState({ isSaving: false, error: err }, () => {
							var that = this
							setTimeout(() => {
								that.setState({ error: null })
							}, 5000)
						})
						message.error(err.message.replace('GraphQL error:',''))
						this.handleFullFocus()
					})
			})
		} else {
			this.setState({ isSaving: true }, () => {
				saveLogs(data)
					.then((response) => {
						this.setState({ isSaving: false })
						this.handleFullFocus()
					})
					.catch(err => {
						console.log('error saving visitor logs', err)
						this.setState({ isSaving: false, error: err }, () => {
							var that = this
							setTimeout(() => {
								that.setState({ error: null })
							}, 5000)
						})
						message.error(err.message.replace('GraphQL error:',''))
						this.handleFullFocus()
					})
			})
		}		
	}

	handleSaveManualLog (values) {
		console.log('values', values)
		const { saveManualDTRLogs } = this.props
		this.setState({ isSavingManualLog: true }, () => {
			saveManualDTRLogs(values)
				.then((response) => {
					this.setState({ isSavingManualLog: false, isManualLogShown: false })
					this.handleFullFocus()
					this.handleFullScreen()
				})
				.catch(err => {
					console.log('error saving manual logs', err)
					this.setState({ isSavingManualLog: false, isManualLogShown: false, error: err }, () => {
						var that = this
						setTimeout(() => {
							that.setState({ error: null })
						}, 5000)
					})
					message.error(err.message.replace('GraphQL error:',''))
					this.handleFullFocus()
					this.handleFullScreen()
				})
		})
	}

	handleFullScreen = () => {
		var elem = document.getElementById('root')
		if (!document.fullscreenElement && !document.mozFullScreenElement &&
			!document.webkitFullscreenElement && !document.msFullscreenElement) {
			if (elem.requestFullscreen) {
				elem.requestFullscreen()
			} else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen()
			} else if (elem.mozRequestFullScreen) {
				elem.mozRequestFullScreen()
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
			}
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen()
			}
		}
	}

	render() {
		const { error, isManualLogShown, isSavingManualLog, isViewDetailShown, scannedConstituentUid } = this.state

		return (
			<React.Fragment>
				<Row style={{ 
					paddingLeft: 20, 
					paddingTop: 5, 
					paddingRight: 20,
					backgroundColor: '#467BAF',
					color: 'white'
				}}>
					<Col md={20} sm={24}>
						<span 
							style={{ 
								color: 'white', 
								fontFamily: 'Verdana', 
								fontSize: '42px',
								letterSpacing: 3
							}}
						>
							<BarangayLogo style={{ marginBottom: 10 }} width={50} height='auto' /> BARANGAY <BarangayName isUpperCase={true} /> (DTR)
						</span>
					</Col>
					<Col md={4} sm={24}>
						<a style={{ fontSize: 30, float: 'right', top: 5 }} className="waves-effect waves-light" onClick={() => {
							this.handleFullScreen()
						}}>
							<i className="mdi mdi-fullscreen noti-icon"></i>
						</a>
					</Col>
				</Row>
				<Row style={{ background: 'white' }}>
					{
						(!isManualLogShown && !isViewDetailShown) &&
						<input 
							// disabled={isSaving} 
							id='qr-input' 
							autoFocus 
							onChange={this.handleQRScan} 
							style={{
								position: 'absolute',
								zIndex: '-1',
								top: '1px'
							}}
						/>
					}
					<DataSubscriber 
						scanError={error}
						setScannedData={(scannedData) => {
							this.setState({ scannedData }, () => {
								if (_.has(scannedData, 'user_type') && 
									_.isEqual(scannedData.user_type, 'CONSTITUENT')) {
									var that = this
									setTimeout(() => {
										that.setState({ isViewDetailShown: true, scannedConstituentUid: scannedData.uid })
									}, 4000)
								}
							})
							var that = this
							setTimeout(() => {
								that.setState({ scannedData: null })
							}, 5000)
						}}
					/>
				</Row>

				{
					isManualLogShown &&
					<ManualLog 
						isSaving={isSavingManualLog}
						visible={isManualLogShown}
						onCancel={() => this.setState({ isManualLogShown: false }, () => {
							this.handleFullFocus()
							this.handleFullScreen()
						})}
						onSubmit={this.handleSaveManualLog}
					/>
				}
				{
					isViewDetailShown &&
					<ViewDetails 
						fromDTR={true}
						constituent_uid={scannedConstituentUid}
						visible={isViewDetailShown}
						onCancel={() => this.setState({ isViewDetailShown: false, scannedConstituentUid: null }, () => {
							this.handleFullFocus()
							// this.handleFullScreen()
						})}
					/>
				}
			</React.Fragment>
		)
	}
}

function IsJsonString(str) {
	try {
		JSON.parse(str)
	} catch (e) {
		return false
	}
	return true
}

const GENERAL_SETTINGS = gql`
    query generalSettings($searchFilter: SearchParams) {
		generalSettings(searchFilter: $searchFilter)
    }
`

const SAVE_LOGS = gql`
    mutation saveVisitorLogs($input: JSON) {
		saveVisitorLogs(input: $input)
    }
`

const SAVE_DTR_LOGS = gql`
    mutation saveDTRLogs($input: JSON) {
		saveDTRLogs(input: $input)
    }
`

const SAVE_MANUAL_DTR_LOGS = gql`
    mutation saveManualDTRLogs($input: JSON) {
		saveManualDTRLogs(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	withRouter,
	graphql(SAVE_LOGS, {
		props({ mutate }) {
			return {
				saveLogs(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['generalSettings']
					})
				}
			}
		}
	}),
	graphql(SAVE_DTR_LOGS, {
		props({ mutate }) {
			return {
				saveDTRLogs(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['generalSettings']
					})
				}
			}
		}
	}),
	graphql(SAVE_MANUAL_DTR_LOGS, {
		props({ mutate }) {
			return {
				saveManualDTRLogs(params) {
					return mutate({
						variables: { input: params },
					  	// refetchQueries: ['generalSettings']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
